import './_styles.scss';
import React from "react";

import {
  FaStar as Full,
  FaStarHalfAlt as Half,
  FaRegStar as Border,
} from 'react-icons/fa';

const Star = ({ count=0, type='EMPTY' }) => {

  let StarType;

  if (count===0) return null;

  switch (type.toUpperCase()) {
    case 'FULL': StarType = Full;
      break;
    case 'HALF': StarType = Half;
      break;
    case 'EMPTY': StarType = Border;
      break;
    default: StarType = Border;
      break;
  }

  return Array.from(Array(count), (x,i) =>
    <StarType
      key={i.toString()}
      className={`icon ${type.toLowerCase()}`}
    />
  );

}

export default ({ score = 1 }) => {

  const ProductScore = (score > 5) ? 5 : score;

  const FullStarCount= parseInt(`${ProductScore}`);

  const HalfScore = ProductScore - FullStarCount;

  const HalfStarCount = (HalfScore > 0) ? 1 : 0;

  const EmptyStarCount = parseInt(5 - ProductScore - HalfScore);

  return (
    <div className='Rating'>
      {<Star count={FullStarCount} type='FULL'/>}
      {<Star count={HalfStarCount} type='HALF'/>}
      {<Star count={EmptyStarCount} type='EMPTY'/>}
    </div>
  )
}
